export const PROVIDER_DATA_NAME_CY_DATA = "provider-data-name-input"
export const PROVIDER_DATA_FILTER_CY_DATA = "provider-data-training-type-input"

export const PROVIDER_DATA_SEARCH_INPUT_CY_DATA = "provider-data-search-input";
export const PROVIDER_DATA_SEARCH_BUTTON_CY_DATA = "provider-data-search-button";
export const PROVIDER_DATA_GRID_CY_DATA = "provider-data-grid-input";
export const PROVIDER_DATA_GRID_ITEM_CY_DATA = "provider-data-grid-item-input";
export const PROVIDER_DATA_GRID_PAGINATION_CY_DATA = "pagination-input";
